"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Validator = void 0;
exports.Validator = {
    validate: (type, value) => {
        if (typeof value === 'string') {
            switch (type) {
                case 'email':
                    return Boolean(value.match(/\b[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z.]{2,30}\b/i));
                default:
                    return false;
            }
        }
        return false;
    },
};
//# sourceMappingURL=Validator.js.map